module.exports = __webpack_public_path__ + "assets/img/news (5).bcd383ac.png";